import React, { useState } from 'react';
import { Camera } from '@/components/camera/camera';
import { createStyles } from '@/contexts/theme-context';
import { LOCATION_MANAGER_ROUTES } from '@/navigators/routes';
import { LocationManagerStackParams } from '@/navigators/types';
import { SingleImagePreviewModal } from '@/components/camera/single-image-preview-modal';
import { StackScreenProps } from '@react-navigation/stack';
import { View } from 'react-native';

type Props = StackScreenProps<
  LocationManagerStackParams,
  LOCATION_MANAGER_ROUTES.MenuCamera
>;

export const MenuCameraScreen: React.FC<Props> = ({ navigation, route }) => {
  const [styles] = useStyles();

  const [photos, setPhotos] = useState<string[]>([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState<number>(0);

  const { restaurantName, restaurantUUID, supplierUUID } = route.params;

  const handleAddPhotos = (newPhotos: string[]) => {
    setPhotos((prevPhotos) => [...prevPhotos, ...newPhotos]);
  };

  const handleDeletePhoto = (index: number) => {
    setIsPreviewOpen(false);
    setPhotos((prevPhotos) => {
      const newPhotos = [...prevPhotos];
      newPhotos.splice(index, 1);
      return newPhotos;
    });
  };

  const handleOpenPreview = (index: number) => {
    setPreviewIndex(index);
    setIsPreviewOpen(true);
  };

  const generateMenuItems = async () => {
    navigation.navigate(LOCATION_MANAGER_ROUTES.ViewImageGeneratedMenu, {
      imageURIs: photos,
      restaurantName: restaurantName,
      restaurantUUID: restaurantUUID,
      supplierUUID: supplierUUID,
    });
  };

  return (
    <View style={styles.background}>
      <Camera
        addPhotos={handleAddPhotos}
        handleClose={() => navigation.goBack()}
        onDeletePhoto={handleDeletePhoto}
        onDone={generateMenuItems}
        onOpenPreview={handleOpenPreview}
        photos={photos}
      />
      <SingleImagePreviewModal
        currentIndex={previewIndex}
        isVisible={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        onDeletePhoto={handleDeletePhoto}
        photos={photos}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  background: {
    backgroundColor: theme.colors.black,
    flex: 1,
  },
}));
